import { FC, ReactNode } from "react";
import { cn } from "~/lib/utils";

interface TabControlBarProps {
  visible?: boolean;
  className?: string;
  children: ReactNode;
}

interface GroupProps {
  className?: string;
  children: ReactNode;
}

const Group: FC<GroupProps> = ({ className, children }) => (
  <div className={cn("flex gap-1 xl:gap-2 items-center", className)}>
    {children}
  </div>
);

const TabControlBar: FC<TabControlBarProps> & { Group: FC<GroupProps> } = ({
  visible = true,
  className,
  children,
}) => {
  if (!visible) return null;
  return (
    <div
      className={cn(
        "w-full h-8 px-6 items-center flex border-t border-border justify-center",
        className
      )}
    >
      {children}
    </div>
  );
};

TabControlBar.Group = Group;

export { TabControlBar };
